import { Navigate, Route, Routes } from 'react-router-dom'
import OrderRoutes from './OrderRoutes'
import CreateTemplatePage from '../templates/presentation/components/pages/CreateTemplatePage/CreateTemplatePage'
import RulesListPage from '../components/pages/RulesListPage/RulesListPage'
import PatternDetailsPage from '../templates/presentation/components/pages/PatternDetailsPage/PatternDetailsPage'
import TemplatePage from '../templates/presentation/components/pages/TemplatePage/TemplatePage'
import { PreAlertPage } from '../components/pages/PreAlertPage/PreAlertPage'

import UserListPage from '../users/presentation/components/page/UserListPage'
import EditTemplatePage from 'templates/presentation/components/pages/EditTemplatePage/EditTemplatePage'
import EditRule from '../components/Rules/pages/EditRule'
import CreateRule from '../components/Rules/pages/CreateRule'
import CreateUserPage from '../users/presentation/components/page/CreateUserPage'
import UpdateUserPage from '../users/presentation/components/page/UpdateUserPage'
import CompanyRoutes from './CompanyRoutes'
import RouteGuard from './RouterGuard'
import { RolePermissions } from 'utils/constants'

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/orders" />} />

            <Route path="/orders/*" element={<OrderRoutes />} />
            <Route path="/packages/create" element={<PreAlertPage />} />
            {/*Templates*/}
            <Route path="/templates" element={<TemplatePage />} />
            <Route path="/templates/create" element={<CreateTemplatePage />} />
            <Route
                path="/templates/edit/:patternId"
                element={<EditTemplatePage />}
            />
            <Route
                path="/templates/show/:patternId"
                element={<PatternDetailsPage />}
            />

            {/*Users*/}
            <Route
                path="/users"
                element={
                    <RouteGuard
                        requiredPermission={[RolePermissions.users.list]}
                    >
                        <UserListPage />
                    </RouteGuard>
                }
            />
            <Route
                path="/users/create"
                element={
                    <RouteGuard
                        requiredPermission={[RolePermissions.users.create]}
                    >
                        <CreateUserPage />
                    </RouteGuard>
                }
            />
            <Route
                path="/users/update/:id"
                element={
                    <RouteGuard
                        requiredPermission={[RolePermissions.users.edit]}
                    >
                        <UpdateUserPage />
                    </RouteGuard>
                }
            />

            {/*Companies*/}
            <Route
                path="/companies/*"
                element={
                    <RouteGuard
                        requiredPermission={[RolePermissions.warehouses.list]}
                    >
                        <CompanyRoutes />
                    </RouteGuard>
                }
            />

            {/*Rules*/}
            <Route path="/rules" element={<RulesListPage />} />
            <Route path="/rules/create" element={<CreateRule />} />
            <Route path="/rules/edit/:id" element={<EditRule />} />

            <Route path="/*" element={<Navigate to="/" />} />
        </Routes>
    )
}

export default AppRoutes
